/**
 * # News Box
 */

/**
 * ## Imports
 */
import './NewsBox.scss';

/**
 * ## Component
 * @param {string} dateTimeAttr
 * @param {string} dateTimeLabel
 * @returns React
 */

const NewsBox = ({ dateTimeAttr, dateTimeLabel, labelHeadline, labelCopyText, imageSrc, isMainNews, imageAlign }) => {
    return (
        <section className={`newsbox${isMainNews ? '' : ' newsbox--sm'}`}>
            <div className="newsbox__image-body">
                {imageSrc ? (
                    <img
                        src={imageSrc}
                        alt=""
                        className={`newsbox__image${imageAlign === 'right' ? ' newsbox__image--alignRight' : ''}`}
                    />
                ) : (
                    <img
                        src="./images/homepage_rebrand/assets/newsroom-placeholder.png"
                        alt=""
                        className="newsbox__image"
                    />
                )}
            </div>
            <div className="newsbox__text-body">
                {dateTimeAttr && dateTimeLabel && (
                    <time dateTime={dateTimeAttr} className="newsbox__pubdate">
                        {dateTimeLabel}
                    </time>
                )}
                {labelHeadline && <h2 className="newsbox__headline">{labelHeadline}</h2>}
                {labelCopyText && <p className="newsbox__paragraph">{labelCopyText}</p>}
            </div>
        </section>
    );
};

export default NewsBox;
